import { Component, OnInit, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { NewEnvelopeService } from 'src/app/envelope/new-envelope/new-envelope.service';
import { NewEnvelopeSteps } from 'src/app/enum/new-envelope-steps';
import { BehaviorSubject } from 'rxjs';
import { SurvicateService } from 'src/app/services/survicate.service';

@Component({
  selector: 'app-general-information',
  templateUrl: './general-information.component.html',
  styleUrls: ['./general-information.component.scss']
})
export class GeneralInformationComponent implements OnInit {

  generalInformationModal: any;
  signatoryInformation: any;
  accessAuthenticationStatus: boolean;
  accessAuthenticationText: string;
  isSignFreemium: boolean = false;

  constructor(private translate: TranslateService, private newEnvelopeService: NewEnvelopeService, private survicateService: SurvicateService,) {
  }

  ngOnInit() {
    this.generalInformationModal = this.newEnvelopeService.getModelData(NewEnvelopeSteps.Settings);
    this.signatoryInformation = this.newEnvelopeService.getModelData(NewEnvelopeSteps.Signatory);
    this.accessAuthenticationStatus = this.signatoryInformation['accessAuthentication'];
    this.isSignFreemium = this.survicateService.isSignFree();

    if (this.accessAuthenticationStatus) {
      this.accessAuthenticationText = this.translate.instant('activated');
    } else {
      this.accessAuthenticationText = this.translate.instant('disabled');
    }

  }
}
